import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { delay, map, Observable, of, startWith } from 'rxjs';
import { InputWithSelectData } from './input-with-select.type';

@UntilDestroy()
@Component({
  selector: 'hk-app-input-with-select',
  templateUrl: './input-with-select.component.html',
})
export class InputWithSelectModalComponent implements OnInit, AfterViewInit {
  @Input() dataOptions = [] as string[];
  @Input() disabled = false;
  @Input() placeholder = '';
  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;
  @ViewChild('options') input?: ElementRef;

  filteredOptions: Observable<string[]> = of([]);
  inputFormControl = new UntypedFormControl();
  inputType = 'input';
  title = '';
  onlyAllowExactMatches = false;
  label = '';

  protected callbacks = {
    onCloseModal: () => {
      //init
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onAcceptModal: (__value?: string) => {
      //init
    },
  };
  private _noAutocomplete = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InputWithSelectData,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    if (this.data.inputTransformFn) this.inputTransformFn = this.data.inputTransformFn;

    this.dataOptions = this.data.dataOptions || [];
    this.placeholder = this.data.placeholder || '';
    this.label = this.data.label || '';
    this.inputType = this.data.inputType || 'input';
    this.inputFormControl.setValue(this.inputTransformFn(this.data.inputValue));
    this.inputFormControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe({ next: (value) => this.inputFormControl.setValue(this.inputTransformFn(value), { emitEvent: false }) });
    this.title = this.data.title || 'NO TITLE';
    this._noAutocomplete = this.data.noAutocomplete || false;
    this.onlyAllowExactMatches = this.data.onlyAllowExactMatches || false;

    if (this.data.onAcceptModal) this.callbacks.onAcceptModal = this.data.onAcceptModal;
    if (this.data.onCancelModal) this.callbacks.onCloseModal = this.data.onCancelModal;
    if (this.data.validationFn) this.inputFormControl.setValidators(this.data.validationFn);

    this.filteredOptions = this.inputFormControl.valueChanges.pipe(
      delay(0),
      startWith(''),
      map((option) => (option ? this._filterStates(option) : [...this.dataOptions])),
    );
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.input?.nativeElement.focus(), 300);
  }

  inputTransformFn = (test?: string) => test || '';

  keyupEnter() {
    if (this._noAutocomplete) {
      this.autocomplete.closePanel();
      this.input?.nativeElement.blur();
    } else {
      this.onAcceptClick();
    }
  }

  onAcceptClick() {
    this.callbacks.onAcceptModal(this.inputFormControl.value);
  }

  private _filterStates(value: string) {
    const filterValue = value.toLowerCase();
    return this.dataOptions.filter((option) => option.toLowerCase().includes(filterValue));
  }
}
